import { CloseButton, OverlayTrigger, Tooltip } from "react-bootstrap";
import type { CaseFileLite } from "@/briefpoint-client";
import styles from "./FileList.module.scss";

interface Props {
  files: CaseFileLite[];
  onDelete: (file: CaseFileLite) => void;
}

export default function FileList(props: Props) {
  return (
    <div className={styles.fileList}>
      {props.files.map((file) => (
        <div key={file.id} className={styles.fileItemContainer}>
          <div
            data-testid="production-file-item"
            className="d-flex justify-content-between p-1 align-items-center"
          >
            <div
              data-testid="production-file-name"
              className={`${styles.fileItemName} ms-2`}
            >
              {file.name}
            </div>
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip data-testid="remove-production-tooltip">
                  <div className="text-center">Remove</div>
                </Tooltip>
              }
            >
              <CloseButton
                data-testid="remove-production-button"
                className={`${styles.closeButton} me-2`}
                onClick={() => props.onDelete(file)}
              />
            </OverlayTrigger>
          </div>
        </div>
      ))}
    </div>
  );
}
